import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.header`
  display: flex;
  align-items: center;
  font-size: ${theme.font.sizes.medium};
  gap: 8px;
  color: ${theme.colors.white};
  font-weight: ${theme.font.bold};

  span {
    font-weight: 700;
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.xlarge};
  }
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;

  svg {
    path {
      fill: ${theme.colors.white};
    }
  }
`
